/*
 * pm-load-more.js — Prototype « Afficher plus » (DEV) — web component intégré à main-collection.
 * Custom element <pm-load-more> : recréé à chaque rendu AJAX d'Impact (filtre/tri) → resynchronisation automatique.
 *
 * Robustesse timing (correctif régression placement) :
 *  - le lien « page suivante » vient de l'attribut data-next-url (fourni par Liquid) → aucune dépendance
 *    à la présence de la pagination native dans le DOM au moment de connectedCallback ;
 *  - la pagination native est masquée par une CLASSE MARQUEUR sur un ancêtre (.collection), via CSS →
 *    fonctionne même si la pagination est parsée après le composant.
 * Garanties conservées : jamais bouton + pagination simultanés (hors filet d'erreur) ; S-A (pas d'URL) ;
 * S-B (pageshow) ; repli natif sur erreur/feature-detect ; append en ignorant les blocs promo.
 */
(function () {
  'use strict';

  var SUPPORTED = (typeof window.fetch === 'function') && (typeof window.DOMParser === 'function') && ('AbortController' in window);

  class PmLoadMore extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.section = this.closest('.shopify-section');
      this.marker = this.closest('.collection') || this.section; // ancêtre présent au moment du connect
      this.list = (this.section && (this.section.querySelector('product-list') || this.section.querySelector('.product-list'))) || null;
      this.btn = this.querySelector('[data-pm-btn]');
      this.statusEl = this.querySelector('[data-pm-status]');
      if (!this.btn) return;

      // Lien "page suivante" fourni par Liquid (indépendant du DOM de la pagination native).
      var dn = this.getAttribute('data-next-url');
      this._next = (dn && dn.length) ? dn : null;

      if (!SUPPORTED || !this.list) {
        this._deactivate();       // laisser la pagination native visible (filet)
        this.btn.hidden = true;
        return;
      }

      try {
        this.sectionId = (this.section.id || '').replace(/^shopify-section-/, '');
        this._controller = new AbortController();
        this.btn.addEventListener('click', this._onClick.bind(this), { signal: this._controller.signal });
        this._sync();
      } catch (e) {
        this._deactivate();
        this.btn.hidden = true;
      }
    }

    disconnectedCallback() { if (this._controller) this._controller.abort(); }

    // Masque la pagination native via classe marqueur (CSS) — insensible au timing de parsing.
    _activate() { if (this.marker) this.marker.classList.add('pm-loadmore-active'); }
    _deactivate() { if (this.marker) this.marker.classList.remove('pm-loadmore-active'); }
    _setLoading(on) { this.btn.disabled = on; this.btn.setAttribute('aria-busy', on ? 'true' : 'false'); this.classList.toggle('pm-loading', on); }

    // Bouton et pagination native mutuellement exclusifs.
    _sync() {
      this._setLoading(false);
      if (this._next) { this._activate(); this.btn.hidden = false; }
      else { this._activate(); this.btn.hidden = true; } // page unique/dernière : pas de bouton ; pas de native trompeuse
    }

    resync() { if (SUPPORTED && this.btn && this._init) this._sync(); }

    _onClick() {
      if (!this._next || this.btn.disabled) return;
      var self = this;
      var url = this._next + (this._next.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(this.sectionId);
      this._setLoading(true);
      if (this.statusEl) this.statusEl.textContent = '';

      window.fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newList = doc.querySelector('product-list') || doc.querySelector('.product-list');
          var added = 0, firstNew = null;
          if (newList && self.list) {
            var frag = document.createDocumentFragment();
            Array.prototype.forEach.call(newList.children, function (node) {
              if (node.classList && node.classList.contains('product-list__promo')) return; // ignorer blocs promo
              var imp = document.importNode(node, true);
              imp.classList.add('pm-appended');
              if (!firstNew) firstNew = imp;
              frag.appendChild(imp);
              added++;
            });
            self.list.appendChild(frag);
          }
          // Lien suivant recalculé depuis le balisage fraîchement récupéré (contient la pagination).
          var np = doc.querySelector('.collection__pagination') || doc.querySelector('.pagination');
          var nn = np ? np.querySelector('a[rel="next"]') : null;
          self._next = nn ? nn.getAttribute('href') : null; // S-A : pas de modification d'URL
          if (window.dataLayer) window.dataLayer.push({ event: 'collection_load_more', products_added: added });
          if (self.statusEl) self.statusEl.textContent = added + ' produit(s) supplémentaire(s) chargé(s).';
          if (firstNew) { var a = firstNew.querySelector('a'); if (a) { a.setAttribute('tabindex', '-1'); try { a.focus({ preventScroll: true }); } catch (e) { a.focus(); } } }
          self._setLoading(false);
          if (!self._next) self.btn.hidden = true; // dernière page
        })
        .catch(function () {
          self._setLoading(false);
          self._deactivate(); // filet de sécurité : la pagination native redevient visible
          if (self.statusEl) self.statusEl.textContent = 'Erreur de chargement. Pagination classique réactivée ; vous pouvez réessayer.';
        });
    }
  }

  if (SUPPORTED && !customElements.get('pm-load-more')) {
    customElements.define('pm-load-more', PmLoadMore);
  }

  // S-B : restauration bfcache → resynchroniser les instances présentes.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var els = document.querySelectorAll('pm-load-more');
    Array.prototype.forEach.call(els, function (el) { if (el && typeof el.resync === 'function') { try { el.resync(); } catch (err) {} } });
  });
})();